import { render, staticRenderFns } from "./BaseModIcon.vue?vue&type=template&id=2f5a39c6&"
import script from "./BaseModIcon.vue?vue&type=script&lang=js&"
export * from "./BaseModIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseModIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports